import {
  FloatingActionBanner,
  FloatingActionBannerButton,
} from './FloatingActionBanner';

type AppUpdateBannerVariant = 'native' | 'web';

interface AppUpdateBannerProps {
  visible: boolean;
  onApply: () => void;
  onDismiss: () => void;
  applying: boolean;
  variant?: AppUpdateBannerVariant;
}

export function AppUpdateBanner({
  visible,
  onApply,
  onDismiss,
  applying,
  variant = 'native',
}: AppUpdateBannerProps) {
  if (!visible) return null;

  const isWebBanner = variant === 'web';
  const copy = isWebBanner
    ? {
        title: 'A new version of Per Diem is available',
        message: 'Refresh to see the latest changes.',
        dismissLabel: 'Not now',
        applyLabel: 'Refresh',
      }
    : {
        title: 'Update ready',
        message:
          'A newer version of Per Diem has been downloaded and is ready to use.',
        dismissLabel: 'Later',
        applyLabel: 'Restart now',
      };

  return (
    <FloatingActionBanner
      title={copy.title}
      message={copy.message}
      iconName={isWebBanner ? 'information-circle' : 'cloud-download'}
      tone={isWebBanner ? 'neutral' : 'success'}
      desktopMaxWidth={520}
      desktopMinWidth={440}
      desktopTopOffset={isWebBanner ? 20 : 16}
      mobileTopOffset={isWebBanner ? 20 : 12}
      actions={
        <>
          <FloatingActionBannerButton onPress={onDismiss} disabled={applying}>
            {copy.dismissLabel}
          </FloatingActionBannerButton>
          <FloatingActionBannerButton
            variant="primary"
            onPress={onApply}
            loading={applying}
          >
            {copy.applyLabel}
          </FloatingActionBannerButton>
        </>
      }
    />
  );
}
